(function () {
  const STORAGE_KEY = "custom_timer_start_time";
  const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

  const getTimerElements = () => {
    return document.querySelectorAll(".button-with-timer-text__timer_block");
  };

  const getStoredStartTime = () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? parseInt(stored, 10) : null;
  };

  const setStoredStartTime = (timestamp) => {
    localStorage.setItem(STORAGE_KEY, timestamp.toString());
  };

  const getTimerDuration = (days) => {
    return days * 24 * 60 * 60 * 1000;
  };

  const calculateTimeDifference = (currentTime, startTime) => {
    return currentTime - startTime;
  };

  const isMultipleOfTwelveHours = (difference) => {
    return difference % TWELVE_HOURS_MS === 0;
  };

  const getNextTwelveHourMultiple = (currentTime) => {
    const remainder = currentTime % TWELVE_HOURS_MS;
    return currentTime - remainder + TWELVE_HOURS_MS;
  };

  const calculateRemainingTime = (timerDurationDays) => {
    const currentTime = Date.now();
    let startTime = getStoredStartTime();

    if (!startTime) {
      startTime = currentTime;
      setStoredStartTime(startTime);
    }

    const difference = calculateTimeDifference(currentTime, startTime);

    if (isMultipleOfTwelveHours(difference)) {
      const newStartTime = currentTime;
      setStoredStartTime(newStartTime);
      return getTimerDuration(timerDurationDays);
    }

    const nextMultiple = getNextTwelveHourMultiple(startTime);
    const remaining = nextMultiple - currentTime;

    if (remaining <= 0) {
      const newStartTime = currentTime;
      setStoredStartTime(newStartTime);
      return getTimerDuration(timerDurationDays);
    }

    return remaining;
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0"),
    };
  };

  const updateTimerElement = (element, time) => {
    const spans = element.querySelectorAll("span");
    if (spans.length >= 3) {
      spans[0].textContent = time.hours;
      spans[1].textContent = time.minutes;
      spans[2].textContent = time.seconds;
    }
  };

  const updateAllTimers = (timerDurationDays) => {
    const elements = getTimerElements();
    if (elements.length === 0) return;

    const remainingTime = calculateRemainingTime(timerDurationDays);
    const time = formatTime(remainingTime);

    elements.forEach((element) => {
      updateTimerElement(element, time);
    });
  };

  const initTimer = (timerDurationDays) => {
    if (typeof timerDurationDays !== "number" || timerDurationDays <= 0) {
      return;
    }

    updateAllTimers(timerDurationDays);

    setInterval(() => {
      updateAllTimers(timerDurationDays);
    }, 1000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      const timerDurationDays = window.customTimerDurationDays;
      if (timerDurationDays) {
        initTimer(timerDurationDays);
      }
    });
  } else {
    const timerDurationDays = window.customTimerDurationDays;
    if (timerDurationDays) {
      initTimer(timerDurationDays);
    }
  }
})();
